import React from 'react';
import { IoChatbubblesOutline, IoClose } from 'react-icons/io5';

interface Props { isOpen: boolean; onClick: () => void; hasActivity?: boolean; }

const ChatButton: React.FC<Props> = ({ isOpen, onClick, hasActivity = false }) => (
  <button className={`bot-fab ${isOpen ? 'bot-fab--open' : ''}`} onClick={onClick} aria-label="Chat">
    {isOpen ? <IoClose size={26} /> : <IoChatbubblesOutline size={26} />}
    {!isOpen && hasActivity && <span className="bot-fab__badge" />}
  </button>
);

export default ChatButton;
